// eslint-disable-next-line max-classes-per-file
/* eslint max-classes-per-file: ["error", 2] */

'use strict';

define('vb/private/stateManagement/storeManager',['vb/private/utils'],
  (Utils) => {
    /**
     * @typedef {import('vb/private/stateManagement/scope.js').default} Scope
     */

    const RULESVALUE_STATEPROPERTY = (property) => `${property}_rulesValue`;

    class Store {
      constructor(scope) {
        this._state = {};

        // Initialize each variable with their initial state
        scope.variablesDef.forEach((variable) => {
          const property = variable.stateProperty;
          if (variable.isValueFromRules()) {
            // we create an additional property on the store for the constant's rulesValue. See variable.js/rulesValue
            const rulesStateProperty = RULESVALUE_STATEPROPERTY(variable.stateProperty);
            this._state[rulesStateProperty] = undefined;
          }
          this._state[property] = variable.getInitialState();
        });

        // All the properties are created and the shape and configurability of
        // the object will not change, so seal it.
        Object.seal(this._state);
      }

      getState(variable) {
        // always retrieve the rules evaluated value stored in a separate store property.
        const property = variable.isValueFromRules() === false ? variable.stateProperty
          : RULESVALUE_STATEPROPERTY(variable.stateProperty);

        return this._state[property];
      }

      updateState(variable, value) {
        // always store the actual rules evaluated value in the separate store property. This ensures actual
        // variable.stateProperty in store is untouched and subscribers are notified.
        const property = variable.isValueFromRules() === false ? variable.stateProperty
          : RULESVALUE_STATEPROPERTY(variable.stateProperty);

        if (this._state[property] !== value) {
          this._state[property] = Utils.cloneObject(value);
        }

        variable.trigger();
      }
    }

    /**
     * A base class to manage store.
     */
    class StoreManager {
      /**
       * Add a scope to the store.
       * @param {Scope} scope a scope object
       */
      static addScopeToStore(scope) {
        if (scope.isStoreInitialized) {
          throw new Error(`Scope ${scope.name} already has store.`);
        }

        // If no variable in the scope yet, nothing to do
        if (Object.keys(scope.variablesDef).length === 0) {
          return;
        }

        scope.syncWithStore(new Store(scope));
      }
    }

    return StoreManager;
  });

